import { Box, Grid, Skeleton } from '@mui/material';

const HotelDetailSkeleton = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#F3F3F3',
        width: '100%',
        minHeight: '100vh',
      }}
    >
      {/* Breadcrumb */}
      <Box className="minWebPadding" sx={{ py: 2 }}>
        <Skeleton variant="text" width="40%" height={32} />
      </Box>

      <Box className="minWebPadding" sx={{ overflow: 'hidden', pb: 2 }}>
        <Grid container spacing={2}>
          {/* Tarjeta principal (BoxHotelDetails) */}
          <Grid item xs={12}>
            <Box
              sx={{
                borderRadius: 2,
                backgroundColor: '#fff',
                p: { xs: 2, sm: 3 },
              }}
            >
              {/* Header del hotel */}
              <Skeleton variant="text" width="60%" height={36} sx={{ mb: 1 }} />
              <Skeleton variant="text" width="30%" height={24} sx={{ mb: 2 }} />

              <Grid container spacing={2} alignItems="flex-start">
                {/* Columna izquierda: imagen + descripción */}
                <Grid item xs={12} md={9}>
                  <Skeleton
                    variant="rectangular"
                    height={300}
                    sx={{ borderRadius: 1 }}
                  />
                  <Skeleton
                    variant="text"
                    width="80%"
                    height={28}
                    sx={{ mt: 2 }}
                  />
                  <Skeleton variant="text" width="95%" height={20} />
                  <Skeleton variant="text" width="90%" height={20} />
                  <Skeleton variant="text" width="70%" height={20} />
                </Grid>

                {/* Columna derecha: sidebar de precios */}
                <Grid item xs={12} md={3}>
                  <Skeleton
                    variant="rectangular"
                    height={220}
                    sx={{ borderRadius: 2 }}
                  />
                </Grid>
              </Grid>
            </Box>
          </Grid>

          {/* Tabla de habitaciones */}
          <Grid item xs={12}>
            <Box
              sx={{ borderRadius: 2, backgroundColor: '#fff', mb: '2vh', p: 2 }}
            >
              <Skeleton variant="text" width="35%" height={32} sx={{ mb: 1 }} />
              {[...Array(4)].map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rectangular"
                  height={64}
                  sx={{ borderRadius: 1, my: 1 }}
                />
              ))}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default HotelDetailSkeleton;
